import React, { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from 'redux/hooks';

import { deleteFeedForm, getAllFeedsData, getFeedOptionsData, updateFeedData, restoreFeedForm, setIsNeedUpdateData } from 'redux/feeds/actions';
import { IFormFeedData } from 'redux/feeds/types';
import ComponentsLoader from 'components/ComponentsLoader/ComponentsLoader';
import FeedForm from "../components/FeedWrapper/FeedForm/FeedForm";
import Actions from "../components/Tables/Actions/Actions";
import {Link} from "react-router-dom";
import url from "../utils/UrlHelper";

const frequency = [
    {
        planName: "Ozon S",
        frequency: 180,
        enable: true
    },
    {
        planName: "plan.names.plan_3",
        frequency: 180,
        enable: false
    },
    {
        planName: "plan.names.plan_2",
        frequency: 60,
        enable: false
    },
    {
        planName: "Ozon XS",
        frequency: 30,
        enable: false
    },
    {
        planName: "plan.names.plan_5",
        frequency: 10,
        enable: false
    },
]

const Tools: React.FC = () => {

    const [allFeedsData, setAllFeedsData] = useState<IFormFeedData[] | []>([]);
    const [isFirstRender, setIsFirstRender] = useState<boolean>(true);

    const dispatch = useAppDispatch();

    const {sellerId, feedOptions, feeds, userId} = useAppSelector(({forms, sellers, feeds, users}) => ({
        sellerId: sellers.currentSeller.info.data?.id,
        feedOptions: feeds.feed,
        feeds: feeds.feed.data.data,
        userId: users.currentUser.info.id
    }));

    const updateFeedDataHandler = (data: IFormFeedData) => {
        setIsFirstRender(false);
        dispatch(updateFeedData(data) as any);
        dispatch(setIsNeedUpdateData(true));
    }

    const deleteFeedHandler = (id: number) => {
        setAllFeedsData(prevState => {
            return prevState.map((element) =>
                element.id !== id ? element : {...element, isDeleted: true}
            )
        });
        dispatch(deleteFeedForm(id) as any);
    }

    const restoreFeedHandler = (id: number) => {
        setAllFeedsData(prevState => {
            return prevState.map((element) =>
                element.id !== id ? element : {...element, isDeleted: false}
            )
        });
        dispatch(restoreFeedForm(id) as any);
    }

    useEffect(() => {
        if(sellerId ) {
            dispatch(getFeedOptionsData(sellerId) as any);
            dispatch(getAllFeedsData(sellerId) as any);
        }
        dispatch(setIsNeedUpdateData(false));

    }, [sellerId, feedOptions.options.isNeedUpdateData]);

    useEffect(() => {
        if(feeds) {
            setAllFeedsData(feeds);
        }
    }, [feeds])


    return (

        <div className="p-4">
            <div className="flex flex-col md:flex-row justify-between">

                <div className="mt-4 md:mt-0 w-full max-w-full overflow-hidden">
                    {/*Actions start*/}
                    <Actions>
                        <div>
                            {/*Tabs start*/}
                            <ul className="style_tabList__2eNFD contact-list" >
                                <li className="pb-[8px]">
                                    <Link className="pr-[20px] mr-4 pb-[8px] text-[#64748B] hover:text-[#1f55a1]" to={url('/:sellerId/tools/barcode', sellerId)}>
                                        Генератор ШК
                                    </Link>
                                </li>
                                <li className="pb-[8px] pr-[20px] mr-4 pb-[8px] text-[#64748B] style_tabLink" aria-selected="true">
                                    YML Feed
                                </li>
                            </ul>
                            {/*Tabs end*/}
                        </div>
                    </Actions>
                    {/*Actions end*/}

                    <div className="flex">
                        <div className="max-w-2xl w-full ">
                            {
                                feedOptions.options.isLoading && isFirstRender ? <div className='my-4'><ComponentsLoader/></div>
                                    :
                                    feedOptions.options.error ? <div className='text-center text-red-500 my-2' data-testid={"feedwrapper-error"}>{feedOptions.options.error}</div>
                                        :
                                        sellerId && userId && feedOptions.options &&
                                        <FeedForm
                                            feeds={allFeedsData}
                                            setFeedData={setAllFeedsData}
                                            data-testid={"feedform-test"}
                                            markets={feedOptions.options.data ? feedOptions.options.data.formats : []}
                                            filters={feedOptions.options.data ? feedOptions.options.data.filters : []}
                                            frequency={frequency}
                                            sellerId={sellerId}
                                            userId={userId}
                                            updateFeedDataHandler={updateFeedDataHandler}
                                            deleteFeedHandler={deleteFeedHandler}
                                            restoreFeedHandler={restoreFeedHandler}
                                        />
                            }
                        </div>

                    </div>

                </div>
            </div>
        </div>



    )
}

export default Tools;